import "core-js/modules/es.string.link.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "news-detail"
  }, [!_vm.showSuccess ? [_c("a-card", {
    attrs: {
      bordered: false,
      title: _vm.$t("newsDetail.basicInfo")
    }
  }, [_c("a-form-model", {
    ref: "newsDetailForm",
    attrs: {
      model: _vm.formData,
      rules: _vm.rules
    }
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      span: 10
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("newsList.title"),
      prop: "title"
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      maxLength: 50,
      placeholder: _vm.$t("publicuse.pleaseinput")
    },
    model: {
      value: _vm.formData.title,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "title", $$v);
      },
      expression: "formData.title"
    }
  })], 1)], 1)], 1), _c("a-row", [_c("a-col", {
    attrs: {
      span: 10
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("newsList.category")
    }
  }, [_c("a-select", {
    attrs: {
      mode: "multiple",
      allowClear: "",
      maxTagCount: 4,
      placeholder: _vm.$t("publicuse.pleaseselect")
    },
    model: {
      value: _vm.formData.categoryList,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "categoryList", $$v);
      },
      expression: "formData.categoryList"
    }
  }, _vm._l(_vm.categoryList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.categoryId
      }
    }, [_vm._v(_vm._s(item.categoryName))]);
  }), 1)], 1)], 1)], 1), _c("a-row", [_c("a-col", {
    attrs: {
      span: 10
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("newsDetail.contentType"),
      prop: "newsContentType"
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.formData.newsContentType,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "newsContentType", $$v);
      },
      expression: "formData.newsContentType"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 0
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("newsDetail.link")) + " ")]), _c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("newsDetail.text")) + " ")])], 1)], 1)], 1)], 1), _vm.formData.newsContentType == 0 ? _c("a-row", {
    key: "link"
  }, [_c("a-col", {
    attrs: {
      span: 10
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("newsDetail.linkContent"),
      prop: "link"
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("publicuse.pleaseinput")
    },
    model: {
      value: _vm.formData.link,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "link", $$v);
      },
      expression: "formData.link"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm.formData.newsContentType == 1 ? _c("a-row", {
    key: "content"
  }, [_c("a-col", {
    attrs: {
      span: 17
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("newsDetail.content"),
      prop: "content"
    }
  }, [_c("tinymce-editor", {
    on: {
      handleImgUpload: _vm.imgUpload
    },
    model: {
      value: _vm.formData.content,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "content", $$v);
      },
      expression: "formData.content"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _c("footer-tool-bar", [_c("a-button", {
    attrs: {
      loading: _vm.submitLoading,
      type: "primary"
    },
    on: {
      click: _vm.formSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t("public.save")))])], 1)], 1), _vm.formData.newsContentType == 1 ? _c("a-card", {
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      bordered: false,
      title: _vm.$t("newsDetail.productInfo")
    }
  }, [_c("a-row", {
    staticStyle: {
      "margin-bottom": "16px"
    },
    attrs: {
      gutter: 12,
      type: "flex",
      justify: "end"
    }
  }, [_c("a-col", [_c("a-button", {
    attrs: {
      type: "primary",
      icon: "plus"
    },
    on: {
      click: _vm.showAddProductModal
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.add")))])], 1)], 1), _c("a-table", {
    attrs: {
      columns: _vm.columns,
      loading: _vm.isTableLoading,
      "data-source": _vm.formData.productList,
      "row-selection": {
        selectedRowKeys: _vm.selectedRowKeys,
        onChange: _vm.onSelectChange
      },
      rowKey: "optionId",
      pagination: {
        pageSizeOptions: ["5", "10", "20", "30"],
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: function showTotal(total, range) {
          return "".concat(_vm.$t("public.total"), "\uFF1A") + _vm.formData.productList.length;
        },
        current: _vm.queryParam.page,
        pageSize: _vm.queryParam.size,
        total: _vm.formData.productList.length
      }
    },
    on: {
      change: _vm.tableChange
    },
    scopedSlots: _vm._u([{
      key: "goodsName",
      fn: function fn(text, record) {
        return [_c("span", [_c("a-tooltip", [_c("template", {
          slot: "title"
        }, [_c("span", [_vm._v(_vm._s(record.productName))])]), _c("router-link", {
          staticClass: "underline",
          attrs: {
            target: "_blank",
            to: {
              path: "/productmanager/productDetail",
              query: {
                id: record.id
              }
            }
          }
        }, [_vm._v(" " + _vm._s(record.productName) + " ")])], 2), _c("br"), _c("span", {
          staticStyle: {
            "margin-top": "5px"
          }
        }, [_vm._v(_vm._s(record.productOptionName))])], 1)];
      }
    }, {
      key: "status",
      fn: function fn(text, record) {
        return [_c("a-tag", {
          attrs: {
            color: record.productStatus == 1 ? "blue" : "red"
          }
        }, [_vm._v(_vm._s(record.productStatus == 0 ? _vm.$t("offSell") : record.productStatus == 1 ? _vm.$t("onSell") : record.productStatus == 2 ? _vm.$t("publicuse.delete") : _vm.$t("public.overSell")))])];
      }
    }, {
      key: "action",
      fn: function fn(text, record) {
        return [_c("a-popconfirm", {
          attrs: {
            title: _vm.$t("publicuse.suerdelete"),
            "ok-text": _vm.$t("publicuse.yes"),
            "cancel-text": _vm.$t("publicuse.no")
          },
          on: {
            confirm: function confirm($event) {
              return _vm.removeProduct(record);
            }
          }
        }, [_c("a", {
          attrs: {
            href: "#"
          }
        }, [_vm._v(_vm._s(_vm.$t("public.delete")))])])];
      }
    }], null, false, 779544192)
  }), _c("div", {
    staticStyle: {
      "margin-top": "-50px"
    }
  }, [_c("span", {
    staticStyle: {
      "margin-right": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.selected")) + _vm._s(this.selectProductList.length) + _vm._s(_vm.$t("public.term")))]), _c("span", {
    staticStyle: {
      "margin-right": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.batchoperation")))]), _c("a-button", {
    attrs: {
      type: "danger"
    },
    on: {
      click: _vm.showRemoveModal
    }
  }, [_vm._v(_vm._s(_vm.$t("public.delete")))])], 1)], 1) : _vm._e()] : _c("a-card", {
    staticClass: "result-card",
    attrs: {
      bordered: false
    }
  }, [_c("div", {
    staticStyle: {
      "max-width": "500px",
      margin: "40px auto 0",
      "text-align": "center"
    }
  }, [_c("result", {
    attrs: {
      title: _vm.$t("public.addSuccessfully"),
      "is-success": true
    }
  }), _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.createAgain
    }
  }, [_vm._v(_vm._s(_vm.$t("public.newagain")))]), _c("a-button", {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      click: _vm.backList
    }
  }, [_vm._v(_vm._s(_vm.$t("public.returntolist")))])], 1)]), _c("selectProduct", {
    ref: "selectModal",
    attrs: {
      alreadySelect: _vm.productOptionIdList
    },
    on: {
      confirmProduct: _vm.confirmProduct
    }
  }), _c("a-modal", {
    attrs: {
      width: "400px",
      title: _vm.$t("batchDelete"),
      destroyOnClose: "",
      maskClosable: false
    },
    model: {
      value: _vm.removeTypeVisible,
      callback: function callback($$v) {
        _vm.removeTypeVisible = $$v;
      },
      expression: "removeTypeVisible"
    }
  }, [_c("a-form-model", {
    attrs: {
      model: _vm.modalValue
    }
  }, [_c("a-form-model-item", [_c("a-radio-group", {
    model: {
      value: _vm.modalValue.removeType,
      callback: function callback($$v) {
        _vm.$set(_vm.modalValue, "removeType", $$v);
      },
      expression: "modalValue.removeType"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 0
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("public.checktheitem")) + " ")]), _c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("public.currentpage")) + " ")]), _c("a-radio", {
    attrs: {
      value: 2
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("public.allpage")) + " ")])], 1)], 1)], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    on: {
      click: function click($event) {
        _vm.removeTypeVisible = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.cancel")))]), _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.removeProduct();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.determine")) + " ")])], 1)], 2)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };